import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "jasbwgTabs"
};
const _hoisted_2 = {
  key: 0,
  class: "tabs"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  key: 1,
  class: "detail"
};
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = {
  key: 1,
  class: "list"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  class: "name"
};
const _hoisted_10 = {
  key: 0,
  class: "noData"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$data.tabs.length > 1 ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.tabs, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      class: _normalizeClass(`${index == $data.activeIndex ? 'active' : ''}`),
      onClick: $event => $options.changeIndex(index)
    }, _toDisplayString(item.name), 11, _hoisted_3);
  }), 256))])) : _createCommentVNode("", true), $data.tabs.length ? (_openBlock(), _createElementBlock("div", _hoisted_4, [$data.tabs[$data.activeIndex].showType > 1 && !_ctx.$route.query.pageId ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "introduction",
    innerHTML: $data.tabs[$data.activeIndex].introduction
  }, null, 8, _hoisted_5)) : _createCommentVNode("", true), $data.tabs[$data.activeIndex].showType == 1 || _ctx.$route.query.pageId ? (_openBlock(), _createElementBlock("ul", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.list, (item, index) => {
    return _withDirectives((_openBlock(), _createElementBlock("li", {
      onClick: $event => $options.toDetail(index),
      class: _normalizeClass({
        'list_1': $data.list1.indexOf(_ctx.$route.query.cid) > -1,
        'list_2': $data.list2.indexOf(_ctx.$route.query.cid) > -1
      })
    }, [$data.list1.indexOf(_ctx.$route.query.cid) > -1 || $data.list2.indexOf(_ctx.$route.query.cid) > -1 ? (_openBlock(), _createElementBlock("img", {
      key: 0,
      src: item.img
    }, null, 8, _hoisted_8)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_9, _toDisplayString(item.name), 1)], 10, _hoisted_7)), [[_vShow, !(_ctx.$route.query.pageId == 412309 && _ctx.$route.query.cid == 6235182 && !index)]]);
  }), 256)), !$data.list.length ? (_openBlock(), _createElementBlock("li", _hoisted_10, "暂无数据")) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]);
}